export default "__VITE_ASSET__DEvlBCHf__"